import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';

export class DateOfBirth extends Component {

    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange : PropTypes.func.isRequired,
        disabled: PropTypes.bool
    };

    state = {
        mode: 'year'
    }

    static defaultProps = {
        disabled: false,
    };
    
    
    handlePanelChange = (value, mode) => {
        this.setState({
            mode: mode ? mode : (this.state.mode === "year" ? "month" : "date")
        });
        this.props.onChange(value);
    }

    handleOpenChange = (open) => {
        if (open) {
            this.setState({ mode: 'year' });
        }
    }

    render() {
        
        return (
            <DatePicker
                value={ this.props.value ? moment(this.props.value) : ''  }
                onChange={ this.props.onChange }
                mode={this.state.mode}
                onOpenChange={this.handleOpenChange}
                onPanelChange={this.handlePanelChange}
                //defaultValue={moment(moment().subtract(20, 'years').format('YYYY')+'01-01', 'YYYY-MM-DD')}
                format="Do MMMM YYYY"
                placeholder="Date de naissance"/>
        );
    }
}

export default DateOfBirth;



// WEBPACK FOOTER //
// ./src/helper/form/input/dateOfBirth.js